import { Tabs as o } from "./Tabs.js";
import { Tab as r } from "./Tab.js";
o.Tab = r;
export { o as Tabs };